export enum RegistryView {
  REQUEST_TYPES = 1,
}
